import React, { useContext } from 'react';
import { BackgroundContext } from '../libs/BackgroundProvider';
import { useGameContext } from "../libs/GameProvider";
import GameCompass from "./game-compass/GameCompass";
import GameGunpowder from "./game-gunpowder/GameGunpowder";
import GamePaperMaking from "./game-paper-making/GamePaperMaking";
import GamePrinting from "./game-printing/GamePrinting";
import GameCover from "./GameCover";
import DevPanel from './ui/DevPanel';
import LottieDiv from './ui/LottieDiv';

const Background = () => {
  const { json, imgFolder, segment } = useContext(BackgroundContext);
  console.log(json);
  if (undefined === json || null === json || null === imgFolder) {
    return <></>;
  } else {
    return <LottieDiv json={json} imgFolder={imgFolder} segment={segment} />;
  }
}

export default function Main() {
  const { game } = useGameContext();

  return (
    <>
      <div className="background" style={{ width: 1280, height: 720, position: 'absolute', top: 0, left: 0 }}>
        <Background />
      </div>

      {'game-cover' === game.status
        ? <GameCover />
        : 'game-paper-making' === game.status
          ? <GamePaperMaking />
          : 'game-compass' === game.status
            ? <GameCompass />
            : 'game-printing' === game.status
              ? <GamePrinting />
              : 'game-gunpowder' === game.status
                ? <GameGunpowder />
                : <div>Wrong Status</div>
      }

      <DevPanel />
    </>
  )
}
